module.exports = __webpack_public_path__ + "static/media/stop-y.fcc5f8ea.png";